import React from "react";
import { HighlightOffRounded as HighlightOffRoundedIcon } from "@mui/icons-material";
import {
  DialogTitle,
  DialogTitleProps,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { isUndefined } from "lodash";
import { AntSwitch } from "../CustomizedComponents/CustomizedComponents";

export interface DialogTitleInterface extends DialogTitleProps {
  onClose: () => void;
  isLocked?: boolean;
  setIsLocked?: React.Dispatch<React.SetStateAction<boolean>>;
  canBeEdited?: boolean;
  hasLock?: boolean;
}
export function CustomDialogTitle(props: DialogTitleInterface) {
  const {
    children,
    onClose,
    isLocked,
    setIsLocked,
    canBeEdited,
    hasLock,
    ...other
  } = props;
  const [checked, setChecked] = React.useState<boolean>(
    !(canBeEdited && !isLocked)
  );
  const theme = useTheme();
  const handleChange = (checked: boolean) => {
    !isUndefined(setIsLocked) && setIsLocked(checked);
    setChecked(checked);
  };
  return (
    <DialogTitle sx={{ m: 0, p: 1, pl: 2 }} {...other}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {children}

        {onClose ? (
          <Stack width="max-content" spacing={1} direction="row">
            {hasLock && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                  variant="body1"
                  color={
                    checked
                      ? theme.palette.warning.main
                      : theme.palette.success.main
                  }
                >
                  {!checked ? "UnLocked" : "Locked"}
                </Typography>
                <AntSwitch
                  invert
                  checked={checked}
                  disabled={!canBeEdited}
                  onChange={(_, checked) => handleChange(checked)}
                />
              </Stack>
            )}
            <IconButton aria-label="close" onClick={onClose} color="error">
              <HighlightOffRoundedIcon />
            </IconButton>
          </Stack>
        ) : null}
      </Stack>
    </DialogTitle>
  );
}
